export const APP_NAME = "Admin Panel";
export const APP_VERSION = "3.0";
export const FORGOT_PASSWORD = "Forgot Password?";
export const PRIMARY_KEY = "id";

export const APP = {
  ROWS_PER_PAGE: 10,
  PAGE_VIEW_OPTIONS: [10, 50, 100, 150],
  MENU_STATUS: [
    { name: "Enabled", value: 1 },
    { name: "Disabled", value: 0 },
  ],
  MENU_TYPE: [
    { name: "Menu", value: 1 },
    { name: "Permission", value: 2 },
  ],
  STATUS: [
    { name: "Enabled", value: 1 },
    { name: "Disabled", value: 2 },
  ],
  NOTIFICATION_STATUS: [
    { name: "Pending", value: 1 },
    { name: "Viewed", value: 2 },
  ],
  EMAIL_TEMPLATE_TYPE: [
    { name: "Default", value: 1 },
    { name: "None", value: 2 },
  ],
};
